import { getMapNode, getStageMap } from "../../content/stages.js";
import type { NodeDefinition, NodeId } from "../../domain/types/index.js";
import { collectEdges, createMapLayout } from "./mapLayout.js";

export function buildMapView(stageId?: string) {
  const nodes = Object.values(getStageMap(stageId));
  return {
    nodes,
    layout: createMapLayout(nodes),
    edges: collectEdges(nodes),
    byId: new Map(nodes.map((node) => [node.id, node])),
  };
}

export function nodeById(id: NodeId, stageId?: string): NodeDefinition | undefined {
  return getMapNode(stageId, id);
}
